import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet9 = async () => {
    return data;
};

// export const getItems9 = async () =>  {
//     console.log("services9")   
//     return data
// };
export const getItems9 = async () =>  {
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
            for (let i = 0; i < Detalhes.autoGridEngarrafado.length ; i++) {
                var EntidadesInstEng = Detalhes.autoGridEngarrafado[i].idAgenteEconomicoEng;
                var idContaCorrenteEngarrafado = Detalhes.autoGridEngarrafado[i].idContaCorrenteEng == 2 ? 'Outros' : Detalhes.autoGridEngarrafado[i].idContaCorrenteEng == 1 ? 'ProdutosSemConta' : Detalhes.autoGridEngarrafado[i].idContaCorrenteEng;
                var idProdutoSemContaEnga = Detalhes.autoGridEngarrafado[i].produtosSemContaEng;
                var numeroGarrafasIVDPEng = Detalhes.autoGridEngarrafado[i].numeroGarrafasIVDP;
                var capacidadeEngarrafado = Detalhes.autoGridEngarrafado[i].capacidadeEngarrafado;
                var IndisponivelEngarrafadoEng = Detalhes.autoGridEngarrafado[i].indisponivelEngarrafado;
                var ProdutoAcabadoEng = Detalhes.autoGridEngarrafado[i].produtoAcabado;
                var ObservacoesEng = Detalhes.autoGridEngarrafado[i].observacoesEng;
                var idAutoDetalhe1 = Detalhes.autoGridEngarrafado[i].idAutoDetalhe;
                var ano = Detalhes.autoGridEngarrafado[i].anoEngarrafado;
                var idcor = Detalhes.autoGridEngarrafado[i].idCorEngarrafado
                data.push({ 
                    idEntidadesInst : EntidadesInstEng,
                    EntidadesInst : EntidadesInstEng,
                    idContaCorrenteEng: idContaCorrenteEngarrafado,
                    idProdutosSemConta : idProdutoSemContaEnga,
                    NGarrafasVist: numeroGarrafasIVDPEng,
                    idCapacidadeEng: capacidadeEngarrafado,
                    QuantidadeApuradaEngarrafado: IndisponivelEngarrafadoEng,
                    //ProdutoAcabado: ProdutoAcabadoEng,
                    Observacoes: ObservacoesEng,
                    idAutoDetalhe: idAutoDetalhe1,
                    Ano: ano,
                    idCor: idcor,
                    Discontinued: false,
                    Columns: [],
                    inEdit: false,
                    ProductID: i + 1,
                })
            }
            return data;
        
    }else{
         return data
    }
    
};
export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
